<template>
    <div class="table-column-header d-flex align-items-center">
        {{ label }}

        <FontAwesomeIcon
            v-if="field.sortable"
            :icon="['fad', icon]"
            class="icon ml-2"
        />
    </div>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {faSort, faSortDown, faSortUp} from '@fortawesome/pro-duotone-svg-icons';
    import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';

    library.add(faSort, faSortDown, faSortUp);

    /**
     * @group Tables
     * A component to utilize a custom column header,
     * with a custom sorting icon, in a `b-table`.
     */
    export default {
        name: 'TableColumnHeader',
        components: {FontAwesomeIcon},
        props: {
            /**
             * Clears the table's selected rows
             */
            clearSelected: {
                type: Function,
                required: true,
            },
            /**
             * The column this component represents
             */
            column: {
                type: String,
                required: true,
            },
            /**
             * The field this component represents
             */
            field: {
                type: Object,
                required: true,
            },
            /**
             * The label that should be shown in the header
             * of this column
             */
            label: {
                type: String,
                required: true,
            },
            /**
             * Selects all of the table's rows
             */
            selectAllRows: {
                type: Function,
                required: true,
            },
            /**
             * The column that the table is sorted by
             */
            sortBy: {
                type: String,
                required: true,
            },
            /**
             * Whether or not the table's sorting is in
             * descending order
             */
            sortDesc: {
                type: Boolean,
            },
        },
        computed: {
            icon() {
                return this.sortBy === this.field.key
                    ? this.sortDesc ? 'sort-down' : 'sort-up'
                    : 'sort';
            },
        },
    };
</script>
